import Button from 'components/Button';
import Footer from 'components/Footer';
import Layout from 'containers/Layout';
import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import { sizes, media } from 'styles/variables';
import Meta from 'utils/Meta';
import RichText from 'utils/RichText';
import GO from 'utils/GO';
import HeaderSimple from 'components/HeaderSimple';

export default props => {
	const lang = props.pageContext.lang || '';
	const [meta] = useState(require(`data/${lang}_meta`));
	const [home] = useState(require(`data/${lang}_home`));

	const Home = styled.div`
		overflow: hidden;
		display: grid;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		width: 100%;
		height: 100%;
		${media.notsmall} {
			grid-template-columns: 1fr 1fr;
		}
		${media.small} {
			grid-template-rows: 1fr auto;
		}
		margin: 0 auto;
		> * {
			align-self: center;
		}
	`;
	const Body = styled.div`
		width: 100%;
		max-width: 700px;
		display: grid;
		grid-gap: ${sizes[2]};
		grid-auto-flow: row;
		padding: ${sizes[3]};
		padding-bottom: calc(${sizes[4]});
		text-align: center;
		justify-items: center;
		z-index: 2;
		.--smaller {
			h1 {
				${media.notlarge} {
					font-size: 1.75rem;
				}
			}
		}
	`;
	const Buttons = styled.div`
		display: grid;
		grid-auto-flow: column;
		${media.notsmall} {
			width: 75%;
			grid-gap: ${sizes[2]};
		}
		${media.small} {
			width: 100%;
			grid-gap: ${sizes[1]};
		}
	`;
	const Cover = styled.div`
		position: relative;
		height: 100%;
		${media.notsmall} {
			.desktop {
				display: block;
				position: fixed;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				z-index: 1;
				background-size: cover;
				background-position: center center;
				background-repeat: no-repeat;
			}
			.mobile,
			.mobile-2 {
				display: none;
			}
		}
		${media.small} {
			.mobile {
				display: block;
				position: absolute;
				top: 0;
				right: 0;
				bottom: -30px;
				left: 0;
				z-index: 1;
				background-size: cover;
				background-position: center bottom;
				background-repeat: no-repeat;
			}
			.mobile-2 {
				display: block;
				position: fixed;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				z-index: 1;
				background-size: cover;
				background-position: center top;
				background-repeat: no-repeat;
			}
			.desktop {
				display: none;
			}
		}
		.color {
			position: fixed;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			z-index: -2;
		}
	`;

	useEffect(() => {
		if (typeof localStorage != 'undefined') {
			localStorage.clear();
		}
	});

	return (
		<>
			<Meta {...props} />
			<Helmet>
				<script type="application/ld+json">
					{JSON.stringify({
						'@context': 'http://schema.org',
						'@type': 'WebPage',
						url: meta.domain,
						name: meta.title,
						description: meta.description,
					})}
				</script>
			</Helmet>
			<Layout>
				<HeaderSimple {...props} />
				<Home>
					{lang === 'keto' && (
						<style>{`
						body *,.headerLink {color:#f7f7f7 !important;}
						.headerLogo svg .fill3 {fill:#fff;}
					`}</style>
					)}
					<Cover>
						<>
							<div
								className="desktop"
								style={{
									backgroundImage: `url(${home.background[0].desktop.url})`,
								}}
							/>
							<div
								className="mobile"
								style={{
									backgroundImage: `url(${home.background[0].mobile.url})`,
								}}
							/>
							<div className="color" style={{ backgroundColor: home.background[0].color }} />
						</>
					</Cover>
					<Body>
						<div className="--smaller">
							<RichText data={home.body_1} />
						</div>
						<Buttons>
							{home.buttons.map((item, index) => (
								<a href={`${lang.length === 0 ? `` : `/${lang}`}${item.link}`} key={index}>
									<Button title={item.title} type={item.type} hue={item.hue} />
								</a>
							))}
						</Buttons>
					</Body>
				</Home>
				<Footer fixed={true} {...props} />
			</Layout>
		</>
	);
};
